module.exports = __webpack_public_path__ + "img/gg.e5d11b44.svg";